<template>
  <div id="app">
    <brand :isLoading="isLoading"></brand>
    <div @click="enterPage" class="start-site">
      <transition name="fade">
        <startsite v-if="isLoading" />
      </transition>
    </div>
    <transition name="slide-fade">
      <router-view class="page-wrap"></router-view>
    </transition>
    <mainfooter></mainfooter>

  </div>
</template>

<script>
import brand from '@/components/_globals/brand/brand.vue'
import mainfooter from '@/components/_globals/mainfooter/mainfooter.vue'
import mainnav from '@/components/_globals/mainnav/mainnav.vue'
import startsite from '@/components/_globals/startsite/startsite.vue'

export default {
  name: 'App',
  components: {
    brand,
    mainfooter,
    mainnav,
    startsite
  },
  data () {
    return {
      isLoading: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.isLoading = false
      this.$store.state.startSite = true
    }, 15000)
  },
  methods: {
    enterPage () {
      this.isLoading = false
      this.$store.state.startSite = true
    }
  }
}
</script>

<style>
  .start-site {
    cursor: pointer;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue